class GeneratorEntity {
  public id?: string;
  public name: string;
  public explanation?: string;
  public categories: string[];
  public path: string;
  public tables: any;
  public self?: string;
  public isDirty?: boolean;
  public hasAllData?: boolean;
  // needed?
  public globals?: any;
  public resultPattern?: string;
  public variables?: any;


  public constructor() {
    this.id = '-1';
    this.name = '';
    this.explanation = '';
    this.categories = [];
    this.path = '';
    this.tables = [];
    this.self = '';
    this.isDirty = false;
    this.hasAllData = false;
  }
}

export default GeneratorEntity;



// WEBPACK FOOTER //
// ./src/models/Generator.ts